/**
 * Zeigt den AudioText an
 * @class directive_v3sSubtitles
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').directive('v3sSubtitles', ['v3sServiceFinder', function (v3sServiceFinder) {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        scope: {
            id: '@',
            v3sFile: '@'
        },
        transclude:true,
        template: '<div class="subtitle-toggle v3s-icon v3s-icon-audiotext-hide"></div>',
        link: function (scope, element, attrs, docCtrl) {
            var v3sGsapService = v3sServiceFinder.get("v3sGsapService");

            var button = angular.element(element.find('div')[0]);

            //subtitle-container muss einen neuen className bekommen, damit wir den Margin
            //ggf wieder rausnehmen können
            var subtitlecontainer = document.querySelector(".subtitle-container");

            //Das Audiotext verstecken bzw. anzeigen
            var toggleShow = function () {
                if (button.hasClass("v3s-icon-audiotext-hide")) {
                    TweenMax.to(element, 0.5, { y: 100 });
                    TweenMax.to(button, 0.5, { className: "subtitle-toggle v3s-icon v3s-icon-audiotext-show" }, 0);
                    TweenMax.to(subtitlecontainer,0.2, { className: "subtitle-container isHidden" });
                } else {
                    TweenMax.to(element, 0.5, { y: 0 });
                    TweenMax.to(button, 0.5, { className: "subtitle-toggle v3s-icon v3s-icon-audiotext-hide" }, 0);
                    TweenMax.to(subtitlecontainer, 0.2, { className: "subtitle-container isShown" });
                }
            }

            button.bind("click", toggleShow);
            if (v3sGsapService) {
                var containerHeight = element[0].offsetHeight;
                v3sGsapService.createDraggable(element, {
                    type: "y",
                    throwProps: true,
                    bounds: {top:element[0].offsetTop, bottom: 0, left: 0, height: containerHeight * 2 - 20 },
                    onDragEnd: function (e) {
                        if (this.endY > 20) {
                            toggleShow();
                        }
                        e.stopPropagation();
                    },
                    onPress: function (e) {
                        e.stopImmediatePropagation();
                        e.stopPropagation();
                        e.preventDefault();
                    }
                });
            }
        }
    }
}]);
